import { applyElevatedCornerRadius, applyElevation, applyFontWeightBold, applyScaledTypeRamp, ElevationMultiplier, focusOutlineWidth, glyphSize, heightNumber, HighContrastColor, highContrastForeground, highContrastHighlightBackground, highContrastOptOutProperty, highContrastSelectedForeground, highContrastSelector, neutralFillStealthActive, neutralFillStealthHover, neutralFocus, neutralForegroundRest, outlineWidth, } from "@microsoft/fast-components-styles-msft";
import { add, applyFocusVisible, applyMaxLines, directionSwitch, format, multiply, toPx, } from "@microsoft/fast-jss-utilities";
const buttonMargin = 8;
const smallImageMargin = 16;
const largeImageMargin = 16;
const iconAttributes = Object.assign({ position: "absolute", display: "inline-block", top: "50%", left: "50%", transform: "translate(-50%, -50%)", height: glyphSize, width: glyphSize }, highContrastForeground);
const styles = {
    topicCard: Object.assign(Object.assign({ position: "relative", width: "100%" }, applyElevatedCornerRadius()), { overflow: "hidden" }),
    topicCard_contentRegion: {
        display: "flex",
        "flex-direction": "row",
        "align-items": "center",
    },
    topicCard_image: {},
    topicCard_topic: Object.assign({ flex: "1", padding: "0", border: "0", "text-decoration": "none", "&::before": {
            content: '""',
            position: "absolute",
            height: "100%",
            width: "100%",
            top: "0",
            left: "0",
        } }, applyFocusVisible({
        "&::before": {
            outline: format("2px solid {0}", neutralFocus),
            [highContrastSelector]: {
                outline: format(`2px solid ${HighContrastColor.selectedBackground}`),
            },
        },
    })),
    topicCard_topicContent: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ "z-index": "1", color: neutralForegroundRest }, applyMaxLines(1, 16)), applyScaledTypeRamp("t8")), applyFontWeightBold()), { "text-overflow": "ellipsis", "text-align": directionSwitch("left", "right") }), highContrastForeground),
    topicCard_followButton: Object.assign(Object.assign({ display: "flex", position: "relative", overflow: "hidden", background: "transparent", "text-transform": "none", "text-decoration": "none", border: "1px solid transparent", padding: "0", cursor: "pointer", fill: neutralForegroundRest, "margin-left": directionSwitch(toPx(buttonMargin), ""), "margin-right": directionSwitch("", toPx(buttonMargin)) }, applyFocusVisible({
        background: neutralFillStealthHover,
        "border-color": neutralFocus,
        "box-shadow": format("inset 0 0 0 1px {0}", neutralFocus),
        [highContrastSelector]: {
            background: HighContrastColor.selectedBackground,
            "border-color": HighContrastColor.buttonText,
            "box-shadow": format(`0 0 0 {0} inset ${HighContrastColor.buttonBackground}`, toPx(focusOutlineWidth)),
        },
        "& $topicCard_isNotFollowedIcon, & $topicCard_isFollowedIcon": Object.assign({}, highContrastSelectedForeground),
    })), { "&:hover": Object.assign(Object.assign({ background: neutralFillStealthHover }, highContrastHighlightBackground), { "& $topicCard_isNotFollowedIcon, & $topicCard_isFollowedIcon": Object.assign({}, highContrastSelectedForeground) }), "&:active": {
            background: neutralFillStealthActive,
        }, [highContrastSelector]: Object.assign(Object.assign({}, highContrastOptOutProperty), { background: HighContrastColor.buttonBackground, border: format(`{0} solid ${HighContrastColor.buttonText}`, toPx(outlineWidth)) }) }),
    topicCard_actionRegion: {},
    topicCard_isFollowedIcon: Object.assign({}, iconAttributes),
    topicCard_isNotFollowedIcon: Object.assign({}, iconAttributes),
    topicCard__isFollowed: {
        "& $topicCard_isFollowedIcon": {
            transition: "all 0.4s 0s ease",
            opacity: "1",
        },
        "& $topicCard_isNotFollowedIcon": {
            opacity: "0",
        },
    },
    topicCard__isNotFollowed: {
        "& $topicCard_isNotFollowedIcon": {
            transition: "all 0.4s 0s ease",
            opacity: "1",
        },
        "& $topicCard_isFollowedIcon": {
            opacity: "0",
        },
    },
    topicCard__backplate: Object.assign(Object.assign({}, applyElevation(ElevationMultiplier.e4)), { transition: "all 0.2s 0s ease", "&:hover": Object.assign(Object.assign({}, applyElevation(ElevationMultiplier.e6)), { [highContrastSelector]: {
                border: format(`{0} solid ${HighContrastColor.selectedBackground}`, toPx(outlineWidth)),
            } }), [highContrastSelector]: Object.assign(Object.assign({}, highContrastOptOutProperty), { border: format(`{0} solid ${HighContrastColor.text}`, toPx(outlineWidth)) }) }),
    topicCard__small: {
        "& $topicCard_followButton": {
            width: toPx(heightNumber(1.5)),
            height: toPx(heightNumber(1.5)),
        },
        "& $topicCard_image": {
            width: toPx(heightNumber(1.5)),
            "max-height": toPx(heightNumber(1.5)),
        },
        "& $topicCard_topic": {
            "margin-left": directionSwitch(toPx(smallImageMargin), ""),
            "margin-right": directionSwitch("", toPx(smallImageMargin)),
            "max-width": `calc(100% - ${toPx(add(multiply(heightNumber(1.5), 2), smallImageMargin))})`,
        },
    },
    topicCard__large: {
        "& $topicCard_followButton": {
            width: toPx(multiply(heightNumber(2.5), 0.75)),
            height: toPx(heightNumber(2.5)),
        },
        "& $topicCard_image": {
            width: toPx(heightNumber(2.5)),
            "max-height": toPx(heightNumber(2.5)),
        },
        "& $topicCard_topic": {
            "margin-left": directionSwitch(toPx(largeImageMargin), ""),
            "margin-right": directionSwitch("", toPx(largeImageMargin)),
            "max-width": `calc(100% - ${toPx(add(heightNumber(2.5), largeImageMargin, multiply(heightNumber(2.5), 0.75)))})`,
        },
    },
};
export default styles;
